export default {"src":"/_next/static/media/heroShieldGreen.aef76a3d.svg","height":121,"width":112,"blurWidth":0,"blurHeight":0};